import {Component, OnInit, AfterViewInit, Inject, Renderer2} from '@angular/core';
import {LoadingSpinnerCounterService} from './modules/common/services/loading-spinner-counter.service';
import {DynamicScriptInjectionService} from './modules/common/services/dynamic-script-injection.service';
import {EnvironmentService} from './modules/common/services/environment-service';
import {DOCUMENT} from '@angular/common';
import {EnvironmentConfig} from '../environments/environment.config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'Greydom';
  themeClass: string;
  faviconIcon: string;

  constructor(
    private environmentService: EnvironmentService,
    private scriptInjectionService: DynamicScriptInjectionService,
    private loadingSpinnerCounterService: LoadingSpinnerCounterService,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
  ) {
    this.themeClass = this.environmentService.getTheme() ?? EnvironmentConfig.themes.Greydom;
    this.faviconIcon = this.environmentService.getFavicon();
  }

  ngOnInit(): void {
    this.renderer.addClass(this.document.body, this.themeClass);
    this.document.getElementById('favicon').setAttribute('href', `/assets/favicons/${this.faviconIcon}`);
  }

  ngAfterViewInit(): void {
    this.scriptInjectionService.injectScript();
  }

  isLoading(): boolean {
    return this.loadingSpinnerCounterService.isLoading();
  }
}
